import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LoginProvider } from '../../providers/myria/login-provider';


@Injectable()
export class LoqateProvider {
  private addressSource: boolean = false;
  private initialAddressState: any = null;
  private isAddressPage: boolean = false;

  constructor(private loginProvider: LoginProvider) {
  }
  
  setIsAddressPage(isAddressPage: boolean) {
    this.isAddressPage = isAddressPage;
  }

  getIsAddressPage(): boolean {
    return this.isAddressPage;
  }
  
  setAddressSource(isFromLoqate: boolean) {
    this.addressSource = isFromLoqate;
  }
  
  getAddressSource(): boolean {
    return this.addressSource;
  }

  setInitialAddressState(state: any) {
    this.initialAddressState = state;
  }

  getInitialAddressState(): any {
    return JSON.stringify(this.initialAddressState);
  }

  handleFormValueChange(form: FormGroup): void {
    
    if (!this.getIsAddressPage()) return;

    if (!form) return;

    const currentForm = JSON.stringify(form.getRawValue());
    const initialForm = this.getInitialAddressState();
    const isFromLoqate = this.getAddressSource();

    if (isFromLoqate) {
      this.setInitialAddressState(form.getRawValue());
      
      const areEqual = (currentForm === initialForm) || initialForm === 'null';
      if (areEqual) {
        form.markAsPristine();
        form.updateValueAndValidity();
      }
    }
    else if (currentForm === initialForm && initialForm !== 'null') {
      form.markAsPristine();
      form.updateValueAndValidity();
    }
  }

  async determineAddressSourceFlag(form: FormGroup, isRegistered: boolean = false): Promise<boolean> {

    if (!this.getIsAddressPage()) return;


    try {
      const isFromLoqate = this.getAddressSource();
      const isFormPristine = form && form.pristine;
      let customerAddressLoqate = false;

      if (isRegistered) {
        const customerV2 = await this.loginProvider.getCustomerAsync();
        customerAddressLoqate = (customerV2 && customerV2.IsAddressSourceLoqate) || false;
      }  
  
      if (isFromLoqate && isFormPristine) {
        customerAddressLoqate = true;
      }
      else if (!isFormPristine) {
        customerAddressLoqate = false;
      }

      this.setAddressSource(false);
      this.setIsAddressPage(false);
      
      return customerAddressLoqate;
    } catch (error) {
      return false;
    }  
  }
}



// WEBPACK FOOTER //
// ./src/providers/loqate/loqate-provider.ts